import makeStyles from "styles/muiStylesCompat/makeStyles";

export default makeStyles((theme) => ({
  button: {
    backgroundColor: theme.palette.error.main,
    border: `2px solid #fff`,
    color: "#fff",
    "&:hover": {
      backgroundColor: "#fff",
      border: `2px solid ${theme.palette.error.main}`,
      color: theme.palette.error.main,
    },
  },
  centerAlign: {
    marginLeft: "auto",
    marginRight: "auto",
  },
}));
